import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import {
  UPLOAD_QUEUE_COPY,
  UPLOAD_QUEUE_INCOMPLETE_DISCARD_DAYS,
} from 'src/utils/invoiceUploadQueueHelpers'

/**
 * Chunk U4/U5 — Incomplete uploads tray on Invoices.
 * “N uploads need review” → Resume reopens the queue on those drafts only.
 */
function IncompleteUploadsTray({
  count = 0,
  onResume,
  disabled = false,
  cleanupBanner = '',
  onDismissBanner,
}) {
  if (!count && !cleanupBanner) return null

  return (
    <TrayStack>
      {cleanupBanner ? (
        <CleanupBanner>
          <span>{cleanupBanner}</span>
          {typeof onDismissBanner === 'function' ? (
            <BannerDismiss type='button' onClick={onDismissBanner}>
              Dismiss
            </BannerDismiss>
          ) : null}
        </CleanupBanner>
      ) : null}
      {count > 0 ? (
        <Tray>
          <TrayCopy>
            <TrayTitle>{UPLOAD_QUEUE_COPY.resumeTrayLabel(count)}</TrayTitle>
            <TrayHint>{UPLOAD_QUEUE_COPY.reviewLaterHint}</TrayHint>
            <TrayHint>
              {UPLOAD_QUEUE_COPY.incompleteDiscardDays(
                UPLOAD_QUEUE_INCOMPLETE_DISCARD_DAYS,
              )}
            </TrayHint>
          </TrayCopy>
          <Button type='default' onClick={onResume} disabled={disabled}>
            Resume review
          </Button>
        </Tray>
      ) : null}
    </TrayStack>
  )
}

export default IncompleteUploadsTray

const TrayStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`

const CleanupBanner = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f6ffed;
  border: 1px solid #b7eb8f;
  font-size: 13px;
  color: #389e0d;
  line-height: 1.4;
`

const BannerDismiss = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #8c8c8c;
  cursor: pointer;
  font-size: 12px;
  padding: 0;

  &:hover {
    color: #595959;
  }
`

const Tray = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
`

const TrayCopy = styled.div`
  min-width: 0;
`

const TrayTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #614700;
`

const TrayHint = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #8c6d1f;
  line-height: 1.35;
`
